const productTypeObject = {
  CATALOG_SUBSCRIPTION: 'CatalogSubscription',
  SPARK_COURSE_SHELL: 'SparkCourseShell',
  SPARK_SPECIALIZATION: 'SparkSpecialization',
  SPARK_VERIFIED_CERTIFICATE: 'SparkVerifiedCertificate',
  SPECIALIZATION: 'Specialization',
  SPECIALIZATION_PREPAID: 'SpecializationPrepaid',
  SPECIALIZATION_SUBSCRIPTION: 'SpecializationSubscription',
  VERIFIED_CERTIFICATE: 'VerifiedCertificate',
  ENTERPRISE_CONTRACT: 'EnterpriseContract',
  INTEREST_DEPOSIT: 'InterestDeposit',
  CREDENTIAL_TRACK_SUBSCRIPTION: 'CredentialTrackSubscription',
  CREDENTIAL_TRACK_SUBSCRIPTION_V2: 'CredentialTrackSubscriptionV2',
  CREDENTIAL_TRACK: 'CredentialTrack',
  COURSERA_PLUS_SUBSCRIPTION: 'CourseraPlusSubscription',
  COURSERA_PLUS: 'CourseraPlus', // coursera plus prepaid
  COURSERA_TIER_LITE: 'CourseraTierLite',
} as const;

export default productTypeObject;

export const {
  CATALOG_SUBSCRIPTION,
  SPARK_COURSE_SHELL,
  SPARK_SPECIALIZATION,
  SPARK_VERIFIED_CERTIFICATE,
  SPECIALIZATION,
  SPECIALIZATION_PREPAID,
  SPECIALIZATION_SUBSCRIPTION,
  VERIFIED_CERTIFICATE,
  ENTERPRISE_CONTRACT,
  INTEREST_DEPOSIT,
  CREDENTIAL_TRACK_SUBSCRIPTION,
  CREDENTIAL_TRACK_SUBSCRIPTION_V2,
  CREDENTIAL_TRACK,
  COURSERA_PLUS_SUBSCRIPTION,
  COURSERA_PLUS,
  COURSERA_TIER_LITE,
} = productTypeObject;

export type ProductType = (typeof productTypeObject)[keyof typeof productTypeObject];
